<div class="card av-wrap">

  <!-- ── Cabecera roja ── -->
  <div class="card-header card-chart card-header-danger d-flex justify-content-between align-items-center">
    <div>
      <h5 class="card-title mb-0 mt-3"><strong>Registrar avance</strong></h5>
      <h4 class="card-category mb-0 " *ngIf="proyecto?.nombre">{{ proyecto.nombre }}</h4>
    </div>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="card-body px-4 pb-0">

    <!-- ── Info bar ── -->
    <div class="d-flex align-items-start gap-4 px-3 py-2 bg-light border-bottom">
      <div class="d-flex flex-column flex-grow-1">
        <span class="av-lbl">Cliente</span>
        <span class="small text-secondary">{{ proyecto?.nombreCliente || '—' }}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="av-lbl">Fecha inicio</span>
        <span class="small text-secondary">{{ proyecto?.fechaInicio | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="av-lbl">Fecha fin</span>
        <span class="small text-secondary">{{ proyecto?.fechaFin | date:'dd/MM/yyyy' }}</span>
      </div>
    </div>

    <!-- ── Avance general ── -->
    <div class="d-flex align-items-center justify-content-between px-3 py-3 border-bottom">
      <div class="flex-grow-1">
        <span class="av-lbl mb-1">Avance general</span>
        <div class="d-flex align-items-baseline gap-2 mb-2">
          <span class="av-kpi-pct" [style.color]="barColor">{{ calcularAvanceGral() }}%</span>
          <span class="small text-muted">Dev 85% + QA 10% + Prod 5%</span>
        </div>
        <div class="progress" style="height:7px">
          <div class="progress-bar" role="progressbar"
               [style.width.%]="calcularAvanceGral()"
               [style.background-color]="barColor"
               [attr.aria-valuenow]="calcularAvanceGral()"
               aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-end ps-4 flex-shrink-0">
        <span class="av-lbl">Meta planeada</span>
        <span class="av-meta-pct fw-semibold text-secondary">{{ proyecto?.avancePlaneado ?? 90 }}%</span>
      </div>
    </div>

    <!-- ── Formulario ── -->
    <div class="px-3 pt-3">

      <!-- Stepper de Fase -->
      <div class="mb-3">
        <div class="d-flex align-items-baseline gap-2 mb-2">
          <span class="av-lbl">Fase</span>
          <span class="av-fase-hint">Selecciona la fase actual para actualizar el % de avance general</span>
        </div>
        <div class="av-stepper">
          <ng-container *ngFor="let f of FASES; let last = last">
            <button type="button"
                    class="av-step"
                    [class.av-step--active]="fase === f.value"
                    [class.av-step--done]="isFasePasada(f.value)"
                    [class.av-step--locked]="f.value === 'PRODUCCION' && !qaSubFasesCompletas && fase !== 'PRODUCCION'"
                    [ngStyle]="chipStyle(f.value)"
                    (click)="setFase(f.value)">
              <span class="av-step__circle">
                <mat-icon class="av-step__icon">{{ f.icon }}</mat-icon>
              </span>
              <span class="av-step__label">{{ f.label }}</span>
            </button>
            <div class="av-step-connector" *ngIf="!last"
                 [style.background-color]="isFasePasada(f.value) ? getFaseColor(f.value) : null">
            </div>
          </ng-container>
        </div>

        <mat-form-field appearance="outline" class="w-100 mt-2"
                        *ngIf="fase === 'DESARROLLO'">
          <mat-label>Avance desarrollo (%)</mat-label>
          <input matInput type="number" [(ngModel)]="avanceReal"
                 name="avanceReal" min="0" max="100" aria-label="Avance desarrollo (%)">
        </mat-form-field>
      </div>

      <!-- Sub-fases QA / Producción -->
      <div class="av-subfases mb-3" *ngIf="fase === 'QA' || fase === 'PRODUCCION'">
        <div class="d-flex align-items-baseline gap-2 mb-2">
          <span class="av-lbl">Sub-fases {{ fase === 'QA' ? 'QA' : 'Producción' }}</span>
          <span class="av-fase-hint">
            Selecciona el hito {{ fase === 'QA' ? 'de QA' : 'de Producción' }} en el que actualmente se encuentra el proyecto. 
          </span>
        </div>
        <div class="d-flex gap-2 flex-wrap mt-1">
          <button type="button" *ngFor="let sf of getSubFasesActivas()"
                  class="av-chip"
                  [class.av-chip--active]="sf.completado"
                  [ngStyle]="{ '--chip-color': faseColor, '--chip-light': faseColorLight }"
                  (click)="toggleSubFase(sf)">
            <mat-icon class="av-chip-icon">{{ sf.icon }}</mat-icon>
            {{ sf.nombre }}
            <span *ngIf="sf.opcional" class="av-opcional">(opcional)</span>
          </button>
        </div>
      </div>

      <!-- Comentario -->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comentario <span style="color:#e53935">*</span></mat-label>
        <textarea matInput [(ngModel)]="comentario" name="comentario"
                  rows="3" maxlength="500"
                  placeholder="ingrese detalles del avance..." aria-label="Comentario *"></textarea>
        <mat-hint align="end">{{ comentario.length }}/500</mat-hint>
      </mat-form-field>

    </div>

    <!-- ── Historial de avances ── -->
    <div class="av-historial px-3 pb-3" *ngIf="historialAvances.length > 0">
      <span class="av-lbl mb-2">Historial de avances</span>
      <div class="av-historial-list">
        <div *ngFor="let h of historialAvances" class="av-historial-item">
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <span class="av-hist-badge"
                  [style.background-color]="getFaseColor(h.fase)"
                  [style.color]="'#fff'">
              <mat-icon class="av-hist-icon">{{ getFaseIcon(h.fase) }}</mat-icon>
              {{ getFaseLabel(h.fase) }}
            </span>
            <span class="av-hist-pct" [style.color]="getFaseColor(h.fase)">
              {{ h.porcentajeRegistrado }}%
            </span>
            <span class="av-hist-dev" *ngIf="(h.fase === 'DESARROLLO' || !h.fase) && h.avanceDesarrollo != null"
                  [style.color]="getFaseColor('DESARROLLO')">
              <mat-icon class="av-hist-dev-icon">trending_up</mat-icon>
              Dev: {{ h.avanceDesarrollo }}%
            </span>
            <span class="av-hist-fecha text-muted">{{ h.fecha }}</span>
            <span class="av-hist-user text-muted ms-auto">{{ h.nombreUsuario }}</span>
          </div>
          <p class="av-hist-desc">{{ h.descripcion }}</p>
          <div *ngIf="h.fase === 'QA' && h.qaSubFases?.length" class="d-flex gap-1 flex-wrap">
            <span *ngFor="let sf of h.qaSubFases"
                  class="av-hist-sf"
                  [class.av-hist-sf--done]="sf.completado">
              {{ sf.nombre }}
            </span>
          </div>
          <div *ngIf="h.fase === 'PRODUCCION' && h.prodSubFases?.length" class="d-flex gap-1 flex-wrap">
            <span *ngFor="let sf of h.prodSubFases"
                  class="av-hist-sf"
                  [class.av-hist-sf--done]="sf.completado">
              {{ sf.nombre }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Acciones ── -->
    <div class="av-actions-bar d-flex justify-content-end align-items-center gap-2 px-3 pt-1 pb-3 border-top">
      <button mat-button class="text-danger" (click)="limpiar()">
        <mat-icon>delete_outline</mat-icon> Limpiar
      </button>
      <button mat-raised-button class="btn btn-success" (click)="save()" [disabled]="isSaving">
        <mat-icon>upload</mat-icon>
        {{ isSaving ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>

  </div><!-- /card-body -->
</div><!-- /card -->
